import { ICard } from './card-types';

export interface HandServerAvailableActions {
  can_check_or_call?: boolean | null;
  can_collect_bets?: boolean | null;
  can_fold?: boolean | null;
  can_post_ante?: boolean | null;
  can_post_blind_or_straddle?: boolean | null;
  can_burn_card?: boolean | null;
  can_deal_hole?: boolean | null;
  can_deal_board?: boolean | null;
  can_stand_pat_or_discard?: boolean | null;
  can_post_bring_in?: boolean | null;
  can_complete_bet_or_raise_to?: boolean | null;
  can_show_or_muck_hole_cards?: boolean | null;
  can_kill_hand?: boolean | null;
  can_push_chips?: boolean | null;
  can_pull_chips?: boolean | null;
  can_win_now?: boolean | null;
  can_select_runout_count?: boolean | null;
}

export interface AvailableActions extends HandServerAvailableActions {
  canCollectBets?: boolean | null;
  canPostAnte?: boolean | null;
  canPostBlindOrStraddle?: boolean | null;
  canBurnCard?: boolean | null;
  canDealHole?: boolean | null;
  canDealBoard?: boolean | null;
  canStandPatOrDiscard?: boolean | null;
  canPostBringIn?: boolean | null;
  canShowOrMuckHoleCards?: boolean | null;
  canKillHand?: boolean | null;
  canPushChips?: boolean | null;
  canPullChips?: boolean | null;
  canWinNow?: boolean | null;
  canFold?: boolean | null;
  canCheck?: boolean | null;
  canCall?: boolean | null;
  canBet?: boolean | null;
  canRaise?: boolean | null;
  canCompleteBetOrRaise?: boolean | null;
  canComplete?: boolean | null;
  canSelectRunoutCount?: boolean | null;
}

export type AvailableActionKey = Extract<keyof AvailableActions, string>;

export interface HandServerHandState {
  status: boolean;
  starting_stacks: number[];
  stacks: number[];
  bets: number[];
  pots: Pot[];
  board_cards: ICard[][];
  blinds_or_straddles: number[];
  street_index?: number | null;
  actor_index?: number | null;
  stander_pat_or_discarder_index?: number | null;
  hole_dealee_index?: number | null;
  showdown_indices?: number[];
  showdown_index?: number | null;
  runout_count?: number;
  player_count: number;
  all_in_status?: boolean;
  all_in_show_status?: boolean;
  checking_or_calling_amount?: number | null;
  completion_betting_or_raising_amount?: number | null;
  effective_bring_in_amount?: number | null;
  min?: number | null;
  max?: number | null;
  min_completion_betting_or_raising_to_amount?: number | null;
  pot_completion_betting_or_raising_to_amount?: number | null;
  max_completion_betting_or_raising_to_amount?: number | null;
  statuses: boolean[];
  hole_cards: ICard[][];
  hole_dealing_statuses: boolean[][];
  all_hole_dealing_statuses: boolean[];
  streets: Street[];
  winning_hands: ICard[][];
  winning_hands_per_board?: ICard[][][]; // [player_index][board_index][cards]
  // many players that can have many hands across many boards
  hands?: string[][][];
  board_dealing_count?: number; // Number of times to deal each street (1 for normal, 2+ for run it multiple times)
}

export interface HandState extends HandServerHandState {
  totalPot: number;
}

export interface Street {
  hole_dealing_statuses: boolean[];
  card_burning_status: boolean;
  skip_betting: boolean;
  board_dealing_count: number;
  draw_status: boolean;
  opening: string;
  min_completion_betting_or_raising_amount: number;
  max_completion_betting_or_raising_count: number;
}

export interface Pot {
  playerIndices?: number[];
  rakedAmount: number;
  unrakedAmount: number;
  amount: number;
}

export interface Operation {
  type: 'Operation';
  subtype: string;
  player_index?: number;
}
